<template>
  <div id="mmWrapper" />
</template>

<script setup>
const { $i18n } = useNuxtApp()

// Enter your Mention Me partner code here:
const partnerCode = "mm14bccb3c";

const urlComponents = [
    "https://tag.mention-me.com/api/v2/referreroffer/",
    partnerCode
]

let queryComponents = [
    [
      "situation",
      "landingpage"
    ],
    [
      "locale",
      $i18n.localeProperties.value.lang + '_' + $i18n.localeProperties.value.countryCode.toUpperCase()
    ],
];

queryComponents = queryComponents.map((qc) => qc[0] + "=" + encodeURIComponent(qc[1]));

const url = urlComponents.join("") + "?" + queryComponents.join("&");

useHead({
  script: [{
    src: url
  }]
})
</script>
